module.exports = __webpack_public_path__ + "static/media/noto-sans-kr-v13-korean-regular.f1c2d455.woff";